/* eslint-disable react-hooks/exhaustive-deps */
import { faThumbtack as faThumbTackLight } from '@fortawesome/pro-light-svg-icons';
import { faThumbTack } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../config/color-palette';

export function PinIt({ onClick, expanded, pinned }: { onClick?: () => void; expanded?: boolean; pinned?: boolean }) {
  if (!expanded) return null;

  let color;
  let tooltipTitle;
  let icon = faThumbTackLight;
  let posRight = 40;
  if (expanded) {
    if (pinned) {
      tooltipTitle = 'Frigør sektion';
      icon = faThumbTack;
      color = ColorPalette.HotAurora;
      posRight = 10;
    } else {
      tooltipTitle = 'Hold sektion åben';
      color = '#535353';
    }
  }
  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          event.preventDefault();
          event.stopPropagation();

          onClick && onClick();
        }}
        sx={{
          pointerEvents: 'all',
          fontSize: 19,
          width: 35,
          height: 35,
          position: 'absolute',
          right: posRight,
          top: '50%',
          transform: 'translateY(-50%)',
          transition: 'opacity .3s linear',
          color,
        }}
      >
        <FontAwesomeIcon icon={icon} />
      </IconButton>
    </Tooltip>
  );
}
